export default "__VITE_ASSET__7e2257d2__"